(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-item"] && !Shopify.designMode) return;
  try {
    function digiMoveProductItemCartButtons(root) {
var scope = root || document;
var rows = scope.querySelectorAll('.product-item__price-row');
rows.forEach(function (priceRow) {
var card = priceRow.closest('.product-item');
if (!card) return;
var slot = card.querySelector('.product-item__cart-slot');
if (!slot) return;
if (priceRow.contains(slot)) return;
priceRow.appendChild(slot);
});
}
digiMoveProductItemCartButtons();
if (!window.digiCartSlotObserver) {
window.digiCartSlotObserver = new MutationObserver(function () {
digiMoveProductItemCartButtons();
});
window.digiCartSlotObserver.observe(document.body, { childList: true, subtree: true });
}
  } catch(e) { console.error(e); }
})();

})();
